// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1zMf3","errors":"Errors_errors__1M2nj"};